import * as React from "react"
import * as ReactDOM from "react-dom"
import "./styles/index.css"
import App from "./components/App"
import Root from "./Root"
import reportWebVitals from "./reportWebVitals"
require("typeface-inter")

ReactDOM.render(
  <React.StrictMode>
    <Root>
      <App />
    </Root>
  </React.StrictMode>,
  document.getElementById("root")
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
